var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tabs',{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('el-tab-pane',{attrs:{"label":"Individuals","name":"individuals"}},[_c('IndividualMenuTypes')],1),_c('el-tab-pane',{attrs:{"label":"Corporates","name":"corporates"}},[_c('CorporateMenuTypes')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }